export const formColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '电表类型：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('meter_type'),
      disabled: true,
    },
    {
      prop: 'spaceName',
      name: '片区：',
      type: 'select',
      span: 12,
      placeholder: '无',
      options: ctx.spaceNameList,
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '电表表编号：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'transformer',
      name: '变压器：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'inductanceRatio',
      name: '电感比/倍率：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'loss',
      name: '损耗：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能电表：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
      disabled: true,
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'auditStatus',
      name: '审核状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('audit-status-02'),
      span: 12,
      disabled: true,
    },
    {
      prop: 'effectiveStatus',
      name: '生效状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('meter_status'),
      span: 12,
      disabled: true,
    },
    {
      prop: 'remark',
      name: '备注：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'createPersonName',
      name: '创建人：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'gmtCreate',
      name: '创建时间：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
  ];
};
export const lineColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '电表类型：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('meter_type'),
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '电表表编号：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'inductanceRatio',
      name: '电感比/倍率：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'loss',
      name: '损耗：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能电表：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
      disabled: true,
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'auditStatus',
      name: '审核状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('audit-status-02'),
      span: 12,
      disabled: true,
    },
    {
      prop: 'effectiveStatus',
      name: '生效状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('meter_status'),
      span: 12,
      disabled: true,
    },
    {
      prop: 'remark',
      name: '备注：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'createPersonName',
      name: '创建人：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'gmtCreate',
      name: '创建时间：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
  ];
};
export const regionColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '电表类型：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('meter_type'),
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '电表表编号：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'inductanceRatio',
      name: '电感比/倍率：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'loss',
      name: '损耗：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能电表：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
      disabled: true,
    },
    {
      prop: 'selfUseFlag',
      name: '是否自用：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
      disabled: true,
    },
    {
      prop: 'virtualTableFlag',
      name: '是否虚拟表：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
      disabled: true,
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'auditStatus',
      name: '审核状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('audit-status-02'),
      span: 12,
      disabled: true,
    },
    {
      prop: 'effectiveStatus',
      name: '生效状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('meter_status'),
      span: 12,
      disabled: true,
    },
    {
      prop: 'remark',
      name: '备注：',
      type: 'input',
      placeholder: '无',
      span: 24,
      disabled: true,
    },
    {
      prop: 'createPersonName',
      name: '创建人：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'gmtCreate',
      name: '创建时间：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
  ];
};
